import React, { useState, useEffect } from 'react'

const liff = window.liff
const closeWindow = liff.closeWindow

const LiffContext = React.createContext(null)
const profile_dev = {
	displayName: 'alice',
	userId: 'uxxxxx',
	pictureUrl: 'https://xxxxx.com/xxx.jpg',
	statusMessage: 'hello world status',
}
const access_token_dev = 'tokendev'

const withLiff = ({liff_id, workflow='prod', auth}) => (
	WrappedComponent,
	LoadingComponent,
) => {
	if (!LoadingComponent) {
		LoadingComponent = () => (<div>Line Connecting...</div>)
	}

	return () => {
		const [isLoading, setIsLoading] = useState(true)
		const [liffData, setLiffData] = useState(null)
		const { mock={}, redirectUri, is_web } = auth

		useEffect(() => {
			const initLiff = async () => {
				liff.init({liffId: liff_id})
					.then(async () => {
						const os = liff.getOS()
						if ((os === 'web') && (!is_web)) {
							throw Error('Please open in Line Mobile')
						}

						const is_login = liff.isLoggedIn()
						if (!is_login) {
							if (redirectUri && is_web) {
								liff.login({ redirectUri })
							}
						}

						const [profile, access_token, version] = await Promise.all([
							liff.getProfile(),
							liff.getAccessToken(),
							liff.getVersion(),
						])
						

						setLiffData({
							profile,
							access_token,
							version,
							os,
						})
						setIsLoading(false)
					})
					.catch((e) => {
						console.error(e)
						if (workflow === 'dev') {		
							setLiffData({
								version: 'mockup',
								profile: profile_dev,
								access_token: access_token_dev,
								...mock,
							})
							setIsLoading(false)
						} else {
							setLiffData({
								error: e.message,
							})
							setIsLoading(false)
						}
					})
			}
			initLiff()
		}, [is_web, mock, redirectUri])

		if (isLoading) {
			return <LoadingComponent />
		}

		return (
			<div>
			{
				liffData && (!liffData.error || workflow === 'dev') && !isLoading ? 
					<LiffContext.Provider value={liffData}>
						<WrappedComponent />
					</LiffContext.Provider>
				: !isLoading && <div>open in line</div>
			}
			</div>
		)
	}
}

export {
	closeWindow,
	withLiff,
	LiffContext,
}